module.exports = __webpack_public_path__ + "img/kuangjiao_zc_songlei.d209046a.jpg";